/**
 * Formata mensagens de erro do pipeline de apresentação para o usuário final:
 * evita exibir stack traces, caminhos em servidor e nomes de módulos internos.
 *
 * @param {string|null|undefined} raw - error_message retornado pela API
 * @param {(key: string, opts?: object) => string} t - função de tradução i18n (ex.: useTranslation('app').t)
 */
export function presentationUserFacingError(raw, t) {
  const s = String(raw || "").trim();
  if (!s) return "";
  const looksTechnical =
    /Runtime\.|ImportModuleError|Cannot find module|Require stack|\/var\/task|\/var\/runtime|\.js:\d+|at\s+async\s+|at\s+_loadUserApp|worker_dispatch_failed:|worker_dispatch_exception:|lambda_invoke|ECONNREFUSED|ETIMEDOUT|ENOTFOUND/i.test(
      s
    );
  if (looksTechnical) {
    return t("workspaceCreate.progress.errorTechnicalSummary", {
      defaultValue:
        "Ocorreu uma falha técnica temporária ao gerar a demonstração. Aguarde alguns minutos, tente criar o workspace novamente ou entre em contato com o suporte.",
    });
  }
  return s;
}
